import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import { useHelpModalState } from 'react-commons';
import { useGlobalState } from '../../../state/persistence';
import { PaymentTypeEnum } from '../../../types';
import { useStyles } from '../../Shared';

const usePaymentType = (nextUrl?: string | Array<string>) => {
  const { t } = useTranslation('payment_type');
  const { toggleHelpModal } = useHelpModalState();
  const history = useHistory();
  const { dispatchQuestion } = useGlobalState();

  const onAdditionalPayment = () => {
    dispatchQuestion('paymentType', PaymentTypeEnum.ADDITIONAL_PAYMENT);

    if (nextUrl) {
      history.push(Array.isArray(nextUrl) ? nextUrl[0] : nextUrl);
    }
  };

  const onCredit = () => {
    dispatchQuestion('paymentType', PaymentTypeEnum.CREDIT);

    if (nextUrl) {
      history.push(Array.isArray(nextUrl) ? nextUrl[1] : nextUrl);
    }
  };

  return {
    classes: useStyles(),
    t,
    onAdditionalPayment,
    onCredit,
    toggleHelpModal,
  };
};

export default usePaymentType;
